import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatAcknowledgmentTimestamp } from '../../utils';

type Props = {
  timestamp: string | null;
};

export const SignatureTimestamp = ({ timestamp }: Props) => {
  const { t } = useTranslation('customerReview');

  if (!timestamp) return null;

  return (
    <Typography
      variant="body2"
      sx={{
        mt: 1,
        color: 'text.secondary',
        fontStyle: 'italic'
      }}
    >
      {t('acknowledgment.signedAt', {
        timestamp: formatAcknowledgmentTimestamp(timestamp)
      })}
    </Typography>
  );
};
